/**
 * Configuração e mock de módulos do Painel de Entrada.
 * Formato esperado da API GET /api/me/modules:
 * @typedef {Object} Module
 * @property {string} id - Identificador único
 * @property {string} name - Nome exibido no card
 * @property {string} path - Rota (React Router)
 * @property {string} icon - Nome do ícone MUI (ex: 'Description', 'VerifiedUser')
 * @property {string} [permission] - Chave de permissão (filtro no backend ou front)
 */

import DescriptionIcon from '@mui/icons-material/Description';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import SchoolIcon from '@mui/icons-material/School';
import GavelIcon from '@mui/icons-material/Gavel';

/** Mapa de ícones por nome (para renderização a partir de string da API) */
export const MODULE_ICONS = {
  Description: DescriptionIcon,
  VerifiedUser: VerifiedUserIcon,
  Slideshow: SlideshowIcon,
  HealthAndSafety: HealthAndSafetyIcon,
  School: SchoolIcon,
  Gavel: GavelIcon,
};

/** Módulo ARCA — exportado para eventual merge quando a API não o incluir. */
export const ARCA_MODULE = {
  id: 'arca',
  name: 'ARCA',
  path: '/arca/pdf',
  icon: 'Slideshow',
  permission: 'arca',
};

/** Módulo Jurídico — entre Contratos e ARCA. */
export const JURIDICO_MODULE = {
  id: 'juridico',
  name: 'Jurídico',
  path: '/juridico/dashboard',
  icon: 'Gavel',
  permission: 'juridico',
};

/** Lista padrão de módulos (mock quando API não existir). */
export const DEFAULT_MODULES = [
  {
    id: 'contratos',
    name: 'Contratos',
    path: '/',
    icon: 'Description',
    permission: 'contratos',
  },
  JURIDICO_MODULE,
  ARCA_MODULE,
  {
    id: 'trilha-aprendizado',
    name: 'Trilha de Aprendizado',
    path: '/trilha-aprendizado',
    icon: 'School',
    permission: 'trilha-aprendizado',
  },
  {
    id: 'qualidade',
    name: 'Qualidade',
    path: '/qualidade',
    icon: 'VerifiedUser',
    permission: 'qualidade',
  },
  {
    id: 'safety-huddle',
    name: 'Safety Huddle',
    path: '/safety-huddle',
    icon: 'HealthAndSafety',
    permission: 'safety-huddle',
  },
];

/**
 * Busca módulos disponíveis para o usuário.
 * Tenta GET /api/me/modules; em caso de falha usa mock.
 * @param {string} backendUrl - Base URL do backend
 * @returns {Promise<Module[]>}
 */
export async function fetchModules(backendUrl) {
  try {
    const res = await fetch(`${backendUrl}/api/me/modules`, {
      credentials: 'include',
      headers: { Accept: 'application/json' },
    });
    if (res.ok) {
      const data = await res.json();
      return Array.isArray(data.modules) ? data.modules : data;
    }
  } catch (e) {
    console.warn('EntryPanel: API /api/me/modules não disponível, usando mock.', e);
  }
  return DEFAULT_MODULES;
}
